const exludes = [
  'login',
  'members'
]

export default {
  showable: () => (route) => {
    const result = exludes.find(name => {
      return route.name === name
    })
    return !result
  },

  username: (state, getters, rootState) => {
    return rootState.user.lastName + ' ' + rootState.user.firstName
  }
}
